// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterLastColumn_root__MDsK5","mobile":"FooterLastColumn_mobile__ANWnM","desktop":"FooterLastColumn_desktop__HcRw7"};